const unauthorizedByRole = {
  title: 'Missing permissions'
}

export default unauthorizedByRole
